export default __webpack_public_path__ + "static/thumbnailBg-d12d363bb860f152543dd12280512c18.png";